import { Moment } from "moment";
import { AnyAction } from "redux";
import { FetchStatus, IAsyncAction, IFetchAction } from "../middleware/fetch-middleware";
import { DateFormat } from "../enums/date-format";
import { string } from "prop-types";
import { IUserDto, ICustomerSecurityQuestionDto, IEthnicityDto, ISpecialty, IInterest, IDesignationDto, IIndividualEthnicityDto, IEmploymentDto, IIndividualSpecialtyDto, IIndividualInterestDto, IIndividualLanguageDto } from "../dtos/user-dto";
import { IDesignation } from "../../my-account/state-helpers/user";
import { isNullOrUndefined } from "util";
import { DefaultFilterableListResults, IFilterableListCriteria, INameAndEmailRequest, IFilterableListResultsDto } from "../dtos/filterable-list-results-dto";

export enum FilterableListApiActions {
    GetResults = 'filterableListApiActions/getResults',
    SaveNameAndEmail = 'filterableListApiActions/saveNameAndEmail',
    ResetGetResultsCallerFlag = 'filterableListApiActions/resetGetResultsCallerFlag'
}

export interface FilterableListApiState {
    results: IFilterableListResultsDto;
    uniqueUserId: string;
    getResultsAsyncCaller: string;
}

export const filterableListApiReducer = (state = DefaultFilterableListResults, action: AnyAction) => {
    switch (action.type) {

        case FilterableListApiActions.GetResults + FetchStatus.Complete:
            return { ...state, results: action.data, getResultsAsyncCaller: action.meta.awaitingCaller };

        case FilterableListApiActions.SaveNameAndEmail + FetchStatus.Complete:
            return { ...state, results: DefaultFilterableListResults.results, uniqueUserId: action.data.uniqueUserId };
        case FilterableListApiActions.ResetGetResultsCallerFlag:
            return { ...state, getResultsAsyncCaller: action.meta.awaitingCaller };
        default: return { DefaultFilterableListResults };
    }
}

const BaseUrl = '/api/v1/filterableList';


export const getResults = (criteria: IFilterableListCriteria, asyncCaller: string = ''): IFetchAction => {
    let test = "test";

    return {
        type: FilterableListApiActions.GetResults,
        fetch: new Request(`${BaseUrl}/getResults`, { method: 'Post', body: JSON.stringify(criteria) }),
        meta: {
            awaitingCaller: asyncCaller,
        }
    }
}

export const saveNameAndEmail = (request: INameAndEmailRequest): IFetchAction => {

    return {
        type: FilterableListApiActions.SaveNameAndEmail,
        fetch: new Request(`${BaseUrl}/saveNameAndEmail`, { method: 'Post', body: JSON.stringify(request) })
    }
}

export const resetGetResultsCallerFlag = (asyncCaller: string = ''): IAsyncAction => {
    return {
        type: FilterableListApiActions.ResetGetResultsCallerFlag,
        meta: {
            awaitingCaller: asyncCaller
        }
    }
}

